import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ReportModel} from '../report.model';
import {Injectable} from '@angular/core';
import {ReportSummaryConverter} from './reportSummary.converter';
import {ReportRecipientConverter} from './reportRecipient.converter';
import {ReportCommunicationContentConverter} from './reportCommunicationContent.converter';
import {DocumentSummaryConverter} from '../../../../../document/common/api/converter/DocumentSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class ReportConverter extends HttpModelConverter<ReportModel> {

    constructor(private reportSummaryConverter: ReportSummaryConverter,
                private reportRecipientConverter: ReportRecipientConverter,
                private contentsConverter: ReportCommunicationContentConverter,
                private documentSummaryConverter: DocumentSummaryConverter) {
        super();
    }
    protected createInstance(): ReportModel {
        return new ReportModel();
    }

    protected enrichObject(result: ReportModel, src: ReportModel) {
        result.summary = this.reportSummaryConverter.convert(src.summary);
        result.recipients = this.reportRecipientConverter.convertFromArray(src.recipients);
        result.contents = this.contentsConverter.convertFromArray(src.contents);
        result.documents = this.documentSummaryConverter.convertFromArray(src.documents);
    }

}
